import { CheckCheck } from "lucide-react";

const MAILTO = "mailto:cbmr71@gmail.com?subject=Agendar%20llamada%20SoytuIA";
const HERO_BG = "https://customer-assets.emergentagent.com/job_ia-concesiones-chile/artifacts/ya5b8ky0_image.png";

const textShadow = { textShadow: "0 2px 12px rgba(0,0,0,0.7)" };
const fontHeading = { fontFamily: "Fraunces, serif" };
const fontBody = { fontFamily: "Outfit, sans-serif" };

export default function HeroSection() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden flex items-center py-20"
    >
      {/* Layer 1: Background image (z-0) */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('${HERO_BG}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* Layer 2: Directional overlay (z-0) */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "linear-gradient(90deg, rgba(17,17,17,0.7) 0%, rgba(17,17,17,0.55) 45%, rgba(17,17,17,0.15) 100%)",
        }}
      />

      {/* Layer 3: Radial overlay behind text (z-0) */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "radial-gradient(ellipse 60% 50% at 50% 50%, rgba(17,17,17,0.6) 0%, rgba(17,17,17,0) 70%)",
        }}
      />

      {/* Layer 4: Bottom gradient fade (z-0) */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#111111] via-[#111111]/40 to-transparent z-0" />

      {/* Layer 5: Content (z-10) */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="flex justify-center">
          <div className="relative z-10 max-w-3xl mx-auto text-center">
            <p
              data-testid="hero-overline"
              className="text-sm sm:text-base uppercase tracking-[0.2em] font-bold text-cyan-400 mb-4 animate-fade-in-up"
              style={{ ...textShadow, ...fontBody }}
            >
              VUELVE A SER DUEÑO DE TU TIEMPO
            </p>

            <h1
              data-testid="hero-headline"
              className="text-3xl sm:text-4xl lg:text-4xl font-medium tracking-tighter leading-[1.2] mb-6 animate-fade-in-up stagger-1"
              style={{ ...textShadow, ...fontHeading }}
            >
              <span className="text-white/70">Vives apagando incendios y las tareas de siempre consumen <span className="text-cyan-400">TU</span> día.</span>
              <br />
              <span className="text-white/70 text-2xl sm:text-3xl lg:text-3xl">El tiempo se escapa y lo importante quedó sin hacer.</span>
              <br />
              <span className="text-white font-medium text-2xl sm:text-3xl lg:text-3xl">Imagina recuperar esas horas y volver a decidir qué hacer con ellas.</span>
            </h1>

            <p
              data-testid="hero-subtitle"
              className="text-xl sm:text-2xl text-white mb-10 mt-10 leading-relaxed animate-fade-in-up stagger-2 mx-auto font-normal"
              style={{ ...textShadow, ...fontBody }}
            >
              En SoytuIA te ayudo a lograrlo, preparando un asistente de IA
              que sabrá perfecto qué hacer, sin olvidar detalles y con
              disponibilidad 24/7.
            </p>

            <div className="animate-fade-in-up stagger-3 flex justify-center lg:justify-center">
              <a
                href={MAILTO}
                data-testid="hero-cta-button"
                className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-full bg-[#FF6B9D] text-white font-semibold text-sm hover:bg-[#FF6B9D]/80 hover:-translate-y-1 transition-transform duration-200 cursor-pointer"
                style={fontBody}
              >
                <CheckCheck size={14} />
                Agenda una llamada gratuita
              </a>
            </div>

            {/* Features list */}
            <ul
              className="mt-8 space-y-0 text-sm text-cyan-400 animate-fade-in-up stagger-4"
              style={fontBody}
            >
              <li className="flex items-center gap-2 justify-center" style={textShadow}>
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 flex-shrink-0" />
                Respuestas correctas en minutos
              </li>
              <li className="flex items-center gap-2 justify-center" style={textShadow}>
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 flex-shrink-0" />
                Entrenado como traje a la medida
              </li>
              <li className="flex items-center gap-2 justify-center" style={textShadow}>
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 flex-shrink-0" />
                100% preparado para responder a tus preguntas
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
